import { Context, Effect, Layer } from "effect";
import { StripeApiClient } from "./StripeApiClient";
const make = Effect.gen(function*() {
    const instance = Effect.gen(function*() {
        const client = yield* StripeApiClient;
        return client;
    });
    return instance;
});
export class StripeApiInstanceProvider extends Context.Tag("@open-revenue/stripe/StripeApiInstanceProvider")() {
    static make = make;
    static layer = Layer.effect(this, make);
}
